document.addEventListener("DOMContentLoaded", function () {
  const nav = document.querySelector("[data-catnav]");
  if (!nav) return;

  const buttons = nav.querySelectorAll(".c-catnav__item");
  const allBtn = nav.querySelector(".is-all");

  buttons.forEach(btn => {
    btn.addEventListener("click", function () {
      const value = this.dataset.value;

      if (value === "all") {
        buttons.forEach(b => b.classList.remove("is-active"));
        this.classList.add("is-active");
        return;
      }

      allBtn.classList.remove("is-active");
      this.classList.toggle("is-active");
    });
  });
});